"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useCallback, useEffect, useLayoutEffect, useRef } from "react";
import type { NotificationDisplayItem } from "@/types/feed.types";
interface UseNotificationsScrollParams {
  readonly items: NotificationDisplayItem[];
  readonly isAuthenticated: boolean;
  readonly isFetchingNextPage: boolean;
  readonly hasNextPage: boolean;
  readonly fetchNextPage: () => void;
  readonly showLoader: boolean;
  readonly showNoItems: boolean;
  readonly showErrorState: boolean;
  readonly activeFilterKey: string;
}
interface UseNotificationsScrollResult {
  readonly scrollContainerRef: RefObject<HTMLDivElement | null>;
  readonly handleTopIntersection: () => void;
}
export const useNotificationsScroll = t0 => {
  const $ = _c(17);
  const {
    items,
    isAuthenticated,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    showLoader,
    showNoItems,
    showErrorState,
    activeFilterKey
  } = t0;
  const scrollContainerRef = useRef(null);
  const hasInitializedScrollRef = useRef(false);
  const shouldEnableInfiniteScroll = isAuthenticated && !showLoader && !showNoItems && !showErrorState;
  let t1;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage || $[2] !== isFetchingNextPage || $[3] !== shouldEnableInfiniteScroll) {
    t1 = () => {
      if (!shouldEnableInfiniteScroll) {
        return;
      }
      if (isFetchingNextPage) {
        return;
      }
      if (!hasNextPage) {
        return;
      }
      fetchNextPage();
    };
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = isFetchingNextPage;
    $[3] = shouldEnableInfiniteScroll;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleTopIntersection = t1;
  let t2;
  if ($[5] !== items.length) {
    t2 = () => {
      const scrollElement = scrollContainerRef.current;
      if (!scrollElement) {
        return;
      }
      if (items.length === 0) {
        return;
      }
      if (!hasInitializedScrollRef.current) {
        scrollElement.scrollTop = 0;
        hasInitializedScrollRef.current = true;
      }
    };
    $[5] = items.length;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== items) {
    t3 = [items];
    $[7] = items;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  useLayoutEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== items.length) {
    t4 = () => {
      if (items.length === 0) {
        hasInitializedScrollRef.current = false;
      }
    };
    t5 = [items.length];
    $[9] = items.length;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      hasInitializedScrollRef.current = false;
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== activeFilterKey) {
    t7 = [activeFilterKey];
    $[13] = activeFilterKey;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  useEffect(t6, t7);
  let t8;
  if ($[15] !== handleTopIntersection) {
    t8 = {
      scrollContainerRef,
      handleTopIntersection
    };
    $[15] = handleTopIntersection;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};